import { ca } from '@cian/analytics';

export function clickSendForm(phone: string, checkbox: boolean, isValid: boolean, userId?: number) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'сlick',
    category: 'applicationPik',
    label: 'send',
    page: {
      pageType: 'CianPikArenda',
      extra: {
        personalData: checkbox,
        filledPhone: phone,
        isValid,
      },
    },
    user: {
      userId,
    },
  });
}

export function clickOpenModal(source: string, userId?: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'сlick',
    category: 'applicationPik',
    label: 'form',
    page: {
      pageType: 'CianPikArenda',
      extra: {
        source,
      },
    },
    user: {
      userId,
    },
  });
}
